module.exports = __webpack_public_path__ + "img/组 2247@2x.2baf17d1.png";